import styled from 'styled-components'

const SkeletonStyled = styled.div`
  animation: fadeInOut 2s infinite linear;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  aspect-ratio: 16 / 9;

  @keyframes fadeInOut {
    0% {
      background-color: ${({ theme }) => theme.old.colors.gray[200]};
      opacity: .9;
    }
    50% {
      background-color: ${({ theme }) => theme.old.colors.gray[100]};
      opacity: .3;
    }
    100% {
      background-color: ${({ theme }) => theme.old.colors.gray[200]};
      opacity: .9;
    }
  }

`

const Skeleton = () => <SkeletonStyled />

export default Skeleton
